import { useParams } from 'react-router-dom';

import { OrganizationUserPage } from '~/components/pages/OrganizationUserPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const OrganizationUserRoute: React.FC = () => {
  const { organizationId, userId } = useParams();

  if (!organizationId) {
    return <Navigate to="/" />;
  }

  if (!userId) {
    return <Navigate to={`/organizations/${organizationId}/users`} />;
  }

  return (
    <DashboardTemplate organizationId={organizationId}>
      <OrganizationUserPage organizationId={organizationId} userId={userId} />
    </DashboardTemplate>
  );
};
